// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickFileInput_wrapper__V717u {
  --foreground-color: var(--foreground-color-1);
  --background-color: var(--background-color-1);
  display: flex;
  flex-direction: column;
  color: var(--foreground-color);
  align-items: flex-start;
  gap: 0.5em;
}
.ClickFileInput_wrapper__V717u .ClickFileInput_preview__ZkvLq {
  border: 2px solid var(--foreground-color-2);
  max-height: 5em;
}
.ClickFileInput_wrapper__V717u .ClickFileInput_name__-IXIL {
  max-width: 20em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ClickFileInput_wrapper__V717u label {
  --height: 2.5rem;
  --borderRadius: calc(var(--height) / 2);
  --transition: all 0.2s;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  gap: 0.5em;
  align-items: center;
  justify-content: center;
  font-weight: var(--bold);
  color: var(--background-color-1);
  background: var(--foreground-color-2);
  height: var(--height);
  border-radius: var(--borderRadius);
  padding-right: var(--borderRadius);
}
.ClickFileInput_wrapper__V717u label .ClickFileInput_icon__p0mtg {
  position: relative;
  height: var(--height);
  width: var(--height);
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ClickFileInput_wrapper__V717u label .ClickFileInput_icon__p0mtg > svg {
  z-index: 1;
}
.ClickFileInput_wrapper__V717u label .ClickFileInput_icon__p0mtg::before {
  content: "";
  position: absolute;
  background: var(--background-color-1);
  display: block;
  height: 0;
  width: 0;
  left: 50%;
  top: 50%;
  transition: var(--transition);
  border-radius: var(--height);
}
.ClickFileInput_wrapper__V717u label:hover {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}
.ClickFileInput_wrapper__V717u label:hover .ClickFileInput_icon__p0mtg {
  color: var(--foreground-color-2);
}
.ClickFileInput_wrapper__V717u label:hover .ClickFileInput_icon__p0mtg::before {
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.ClickFileInput_wrapper__V717u label:active {
  transform: scale3d(0.9, 0.9, 1);
  filter: brightness(0.9);
}
.ClickFileInput_wrapper__V717u input {
  position: absolute;
  left: -9999px;
}
.ClickFileInput_wrapper__V717u input:focus + label {
  box-shadow: 0 0 0 4px var(--background-color-2-alpha);
}

.ClickFileInput_errorMessage__P1p5z {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickFileInput.module.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,6CAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;AAAF;AACE;EACE,2CAAA;EACA,eAAA;AACJ;AACE;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AACE;EACE,gBAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,kCAAA;EACA,kCAAA;AACJ;AAAI;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEN;AADM;EACE,UAAA;AAGR;AADM;EACE,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;EACA,4BAAA;AAGR;AAAI;EACE,0CAAA;AAEN;AADM;EACE,gCAAA;AAGR;AAFQ;EACE,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;AAIV;AAAI;EACE,+BAAA;EACA,uBAAA;AAEN;AACE;EACE,kBAAA;EACA,aAAA;AACJ;AAAI;EACE,qDAAA;AAEN;;AAEA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AACF","sourcesContent":[".wrapper {\n  --foreground-color: var(--foreground-color-1);\n  --background-color: var(--background-color-1);\n\n  display: flex;\n  flex-direction: column;\n  color: var(--foreground-color);\n  align-items: flex-start;\n  gap: 0.5em;\n  .preview {\n    border: 2px solid var(--foreground-color-2);\n    max-height: 5em;\n  }\n  .name {\n    max-width: 20em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  label {\n    --height: 2.5rem;\n    --borderRadius: calc(var(--height) / 2);\n    --transition: all 0.2s;\n    cursor: pointer;\n    transition: var(--transition);\n    display: flex;\n    gap: 0.5em;\n    align-items: center;\n    justify-content: center;\n    font-weight: var(--bold);\n    color: var(--background-color-1);\n    background: var(--foreground-color-2);\n    height: var(--height);\n    border-radius: var(--borderRadius);\n    padding-right: var(--borderRadius);\n    .icon {\n      position: relative;\n      height: var(--height);\n      width: var(--height);\n      transition: var(--transition);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      & > svg {\n        z-index: 1;\n      }\n      &::before {\n        content: \"\";\n        position: absolute;\n        background: var(--background-color-1);\n        display: block;\n        height: 0;\n        width: 0;\n        left: 50%;\n        top: 50%;\n        transition: var(--transition);\n        border-radius: var(--height);\n      }\n    }\n    &:hover {\n      box-shadow: 1px 1px 5px rgba(black, 0.5);\n      .icon {\n        color: var(--foreground-color-2);\n        &::before {\n          height: 100%;\n          width: 100%;\n          left: 0;\n          top: 0;\n        }\n      }\n    }\n    &:active {\n      transform: scale3d(0.9, 0.9, 1);\n      filter: brightness(0.9);\n    }\n  }\n  input {\n    position: absolute;\n    left: -9999px;\n    &:focus + label {\n      box-shadow: 0 0 0 4px var(--background-color-2-alpha);\n    }\n  }\n}\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ClickFileInput_wrapper__V717u`,
	"preview": `ClickFileInput_preview__ZkvLq`,
	"name": `ClickFileInput_name__-IXIL`,
	"icon": `ClickFileInput_icon__p0mtg`,
	"errorMessage": `ClickFileInput_errorMessage__P1p5z`
};
export default ___CSS_LOADER_EXPORT___;
